module.exports = __webpack_public_path__ + "static/media/bang0.05bc76d2.mp3";